module.exports = __webpack_public_path__ + "tw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tw.svg
// module id = 858
// module chunks = 0